import React, {useState} from "react";
import { Table, Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import commaNumber from "comma-number";

const format = commaNumber.bindWith(",", ".");

const CustomerDueTable = ({ printMode = false, authInfo }) => {
  const { list, loading, filters, totalBalance } = useSelector((state) => state.customerDue);


  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };



  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "Code", dataIndex: "acc_code" },
    { title: "Customer Name", dataIndex: "acc_name" },
    { title: "Contact No", dataIndex: "contact_no" },
    { title: "Address", dataIndex: "address" },
    {
      title: "Opening",
      dataIndex: "opening_balance",
      render: (val) => format(parseFloat(val || 0).toFixed(2))
    },
    {
      title: "Bill Amount",
      dataIndex: "total_bill_amount",
      render: (val) => format(parseFloat(val || 0).toFixed(2))
    },
    {
      title: "Received",
      dataIndex: "total_received_amount",
      render: (val) => format(parseFloat(val || 0).toFixed(2))
    },
    {
      title: "Payment",
      dataIndex: "total_payment",
      render: (val) => format(parseFloat(val || 0).toFixed(2))
    },
    {
      title: "Return",
      dataIndex: "return_amount",
      render: (val) => format(parseFloat(val || 0).toFixed(2))
    },
    {
      title: "Discount",
      dataIndex: "discount_amount",
      render: (val) => format(parseFloat(val || 0).toFixed(2))
    },
    {
      title: "Balance",
      dataIndex: "balance",
      render: (val) => format(parseFloat(val || 0).toFixed(2))
    },
    ...(authInfo?.branch_company_type === "Pharmacy" ? [
      {
        title: "Insurance Amount",
        dataIndex: "insurance_due_amount",
        render: (val) => format(parseFloat(val || 0).toFixed(2))
      },
      {
        title: "Insurance Amount Paid",
        dataIndex: "insurance_amount_received",
        render: (val) => format(parseFloat(val || 0).toFixed(2))
      }
    ] : []),

    ...(filters.filterType === "By Tag" ? [
      { title: "Tag Group", dataIndex: "tag_group" },
      { title: "Tag Field", dataIndex: "tag_field" }
    ] : []),
    // !printMode && {
    //   title: "Actions",
    //   className: "no-print",
    //   render: () => (
    //     <Button type="link" icon={<PrinterOutlined style={{ color: "green" }} />} />
    //   ),
    // },
  ].filter(Boolean);

  const calculateTotals = () => {
    return list.reduce((acc, row) => ({
      opening: acc.opening + parseFloat(row.opening_balance || 0),
      billAmount: acc.billAmount + parseFloat(row.total_bill_amount || 0),
      received: acc.received + parseFloat(row.total_received_amount || 0),
      payment: acc.payment + parseFloat(row.total_payment || 0),
      return: acc.return + parseFloat(row.return_amount || 0),
      discount: acc.discount + parseFloat(row.discount_amount || 0),
      insuranceDue: acc.insuranceDue + parseFloat(row.insurance_due_amount || 0),
      insuranceCredit: acc.insuranceCredit + parseFloat(row.insurance_amount_received || 0),
    }), {
      opening: 0, billAmount: 0, received: 0, payment: 0,
      return: 0, discount: 0, insuranceDue: 0, insuranceCredit: 0
    });
  };

  const totals = calculateTotals();

 if (printMode) {
  return (
    <table className="ledger-print-table">
      <thead>
        <tr className="ledger-print-heading">
          <td style={{
            width:'30px', maxWidth: '30px'
          }} >No.</td>
          <td>Code</td>
          <td>Customer Name</td>
          <td>Contact No</td>
          <td>Address</td>
          <td style={{ textAlign: "center" }}>Bill Amt</td>
          <td style={{ textAlign: "right" }}>Received</td>
          <td style={{ textAlign: "right" }}>Payment</td>
          <td style={{ textAlign: "right" }}>Return</td>
          <td style={{ textAlign: "right" }}>Discount</td>
          <td style={{ textAlign: "right" }}>Balance</td>

          {authInfo?.branch_company_type === "Pharmacy" && (
            <>
              <td style={{ textAlign: "right" }}>Insurance Amount</td>
              <td style={{ textAlign: "right" }}>Insurance Paid</td>
            </>
          )}

          {filters.filterType === "By Tag" && (
            <>
              <td>Tag Group</td>
              <td>Tag Field</td>
            </>
          )}
        </tr>
      </thead>

      <tbody>
        {list.map((row, index) => (
          <tr key={`${row.acc_id}-${index}`}>
  <td>{index + 1}</td>
  <td>{row.acc_code}</td>
  <td>{row.acc_name}</td>
  <td style={{
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word"
  }}>{row.contact_no}</td>

  <td style={{
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word"
  }}>
    {row.address}
  </td>



  <td style={{
    whiteSpace: "nowrap",
    minWidth: "90px",
    textAlign: "right"
  }}>
    {format(Number(row.total_bill_amount || 0).toFixed(2))}
  </td>

  <td style={{ textAlign: "right" }}>
    {format(Number(row.total_received_amount || 0).toFixed(2))}
  </td>

  <td style={{ textAlign: "right" }}>
    {format(Number(row.total_payment || 0).toFixed(2))}
  </td>

  <td style={{ textAlign: "right" }}>
    {format(Number(row.return_amount || 0).toFixed(2))}
  </td>

  <td style={{ textAlign: "right" }}>
    {format(Number(row.discount_amount || 0).toFixed(2))}
  </td>

  <td style={{ textAlign: "right" }}>
    {format(Number(row.balance || 0).toFixed(2))}
  </td>
</tr>
        ))}

        <tr className="ledger-print-total">
          <td colSpan={5} style={{ textAlign: "right" }}>
            Grand Total :
          </td>
          <td style={{ textAlign: "right" }}>{format(totals.billAmount.toFixed(2))}</td>
          <td style={{ textAlign: "right" }}>{format(totals.received.toFixed(2))}</td>
          <td style={{ textAlign: "right" }}>{format(totals.payment.toFixed(2))}</td>
          <td style={{ textAlign: "right" }}>{format(totals.return.toFixed(2))}</td>
          <td style={{ textAlign: "right" }}>{format(totals.discount.toFixed(2))}</td>
          <td style={{ textAlign: "right" }}>{format(totalBalance.toFixed(2))}</td>

          {authInfo?.branch_company_type === "Pharmacy" && (
            <>
              <td style={{ textAlign: "right" }}>
                {format(totals.insuranceDue.toFixed(2))}
              </td>
              <td style={{ textAlign: "right" }}>
                {format(totals.insuranceCredit.toFixed(2))}
              </td>
            </>
          )}

          {filters.filterType === "By Tag" && (
            <>
              <td></td>
              <td></td>
            </>
          )}
        </tr>
      </tbody>
    </table>
  );
}

  return (
    <Table
      rowKey={(record, index) => `${record.acc_id}-${index}`}
      columns={columns}
      dataSource={list}
      data-testid="customer-due-table"
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      scroll={printMode ? undefined : { x: 'max-content' }}
      size={printMode ? "small" : "middle"}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={5}>
            <strong>Grand Total</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6}>
            <strong>{format(totals.opening.toFixed(2))}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={7}>
            <strong>{format(totals.billAmount.toFixed(2))}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={8}>
            <strong>{format(totals.received.toFixed(2))}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={9}>
            <strong>{format(totals.payment.toFixed(2))}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={10}>
            <strong>{format(totals.return.toFixed(2))}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={11}>
            <strong>{format(totals.discount.toFixed(2))}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={12}>
            <strong>{format(totalBalance.toFixed(2))}</strong>
          </Table.Summary.Cell>

          {authInfo?.branch_company_type === "Pharmacy" && (
            <>
              <Table.Summary.Cell index={13}>
                <strong>{format(totals.insuranceDue.toFixed(2))}</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={14}>
                <strong>{format(totals.insuranceCredit.toFixed(2))}</strong>
              </Table.Summary.Cell>
            </>
          )}

          {!printMode && <Table.Summary.Cell index={15}></Table.Summary.Cell>}
        </Table.Summary.Row>
      )}
    />
  );
};

export default CustomerDueTable;
